<template>
  <div id="Password">
    <Navbar :title="$t('修改登录密码')" />
    <LoginForm isLabel isLogin :formList="formList" confirmText="newAdd.Submit" @submit="onSubmit">
      <template #read>
        <div class="text">{{ $t("My.PersonalInformation.Password.Text") }}</div>
      </template>
      <template #cancel>
        <div></div>
      </template>
    </LoginForm>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import LoginForm from "@/view/login/components/form.vue";
import { maskMiddle } from "@/utils/common"
import { Toast } from "vant";

export default {
  name: "portrait",
  components: {
    [Toast.name]: Toast,
    Navbar,
    LoginForm,
  },
  data() {
    return {
      formList: [
        {
          key: "userphone",
          disabled: true,
          icon: "icon-tongyong-yonghumingtubiao",
          label: "My.PersonalInformation.Password.NewPhone",
        },
        {
          key: "oldpass",
          icon: "icon-mima",
          label: "My.PersonalInformation.Password.oldPass",
        },
        {
          key: "newpass",
          icon: "icon-mima",
          label: "My.PersonalInformation.Password.ConfirmPasswordNote",
        },
      ],
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    onSubmit(values) {
      console.log(values);
      
      Toast.loading({ duration: 0 });
      const { oldpass, newpass } = values;
      this.$api.editPwd({
        oldpass,
        newpass,
      }, (res) => {
        Toast.clear();
        Toast(res.msg);
        setTimeout(() => {
          this.$router.replace({ name: "login" });
        }, 800);
      }, (err) => {
        Toast.clear();
        Toast(err.data.msg);
      });
    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo(
        (res) => {
          // this.DataArr.Phone = res.userphone;
          const index = this.formList.findIndex(
            (item) => item.key === "userphone"
          );
          if (index !== -1) {
            const item = this.formList[index];
            item.defaultValue = res.userphone;
            this.$set(this.formList, index, { ...item, defaultValue: maskMiddle(item.defaultValue) });
          }
          Toast.clear();
        },
        (err) => {
          Toast.clear();
          this.$toast(err);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
#Password {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #F5F5F9;

  .text {
    color: #5e5e5e;
    font-size: 0.75rem;
    margin-top: calc(20rem / 16);
  }

  /deep/ .form_list {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 10px 10px 18px;
    .van-cell {
      background-color: #efefef !important;
      padding: 0 20px;
      border-radius: calc(10rem / 16);

      .van-field__body {
        height: 52px;
        line-height: 52px;
        background-color: transparent;
        padding: 0 0 0 10px;
      }

      input {
        color: #333;
      }
    }

    .iconfont {
      color: #a5a5a5;
    }

    .confirm {
      color: #fffefe !important;
      font-size: calc(14rem / 16);
      border-radius: calc(100rem / 16) !important;
      height: calc(44rem / 16);
      text-align: center;
      margin-top: calc(30rem / 16);
      text-shadow: 0 1px 1px #5f4a21;
      background: linear-gradient(90deg, #18b38d, #35d49a);
      transition: all .3s ease;
      padding: 4px 10px;
      border-color: #1989fa !important;
    }
  }

}
</style>